const currentPageAllowsContextPreserve = () => {
    const pageContent = document.querySelector('#page-content');

    return pageContent instanceof HTMLElement
        && pageContent.dataset.managementContextPreserve === '1';
};

const buildCurrentContextUrl = (contextRoot, sportKey, teamKey, fallbackType) => {
    const fallback = fallbackType === 'sport'
        ? contextRoot.dataset.sportFallbackUrl
        : contextRoot.dataset.teamFallbackUrl;
    const preserveCurrentPage = currentPageAllowsContextPreserve();
    const target = preserveCurrentPage
        ? new URL(window.location.href)
        : new URL(fallback || window.location.href, window.location.origin);

    target.searchParams.delete('sport');
    target.searchParams.delete('team');

    if (sportKey) {
        target.searchParams.set('sport', String(sportKey));
    }
    if (teamKey) {
        target.searchParams.set('team', String(teamKey));
    }

    if (!preserveCurrentPage) {
        target.hash = '';
    }

    return `${target.pathname}${target.search}${target.hash}`;
};

const syncContextLinks = (contextRoot) => {
    contextRoot.querySelectorAll('[data-sport-switch]').forEach((sportSwitch) => {
        if (!(sportSwitch instanceof HTMLAnchorElement)) {
            return;
        }

        sportSwitch.href = buildCurrentContextUrl(
            contextRoot,
            sportSwitch.dataset.sportKey,
            sportSwitch.dataset.teamKey,
            'sport'
        );
    });

    contextRoot.querySelectorAll('[data-team-switch]').forEach((teamSwitch) => {
        if (!(teamSwitch instanceof HTMLAnchorElement)) {
            return;
        }

        teamSwitch.href = buildCurrentContextUrl(
            contextRoot,
            contextRoot.dataset.activeSport,
            teamSwitch.dataset.teamKey,
            'team'
        );
    });
};

const navigateContext = (contextRoot, switchElement, type) => {
    const sportKey = type === 'sport'
        ? switchElement.dataset.sportKey
        : contextRoot.dataset.activeSport;
    const teamKey = switchElement.dataset.teamKey;

    if (!sportKey) {
        return;
    }

    const targetUrl = buildCurrentContextUrl(
        contextRoot,
        sportKey,
        teamKey,
        type
    );

    window.location.assign(targetUrl);
};

const initializeManagementContext = (root = document) => {
    root
        .querySelectorAll('[data-management-context]')
        .forEach((contextRoot) => {
            if (
                contextRoot.dataset.managementContextInitialized
                === 'true'
            ) {
                return;
            }

            contextRoot.dataset.managementContextInitialized = 'true';
            syncContextLinks(contextRoot);

            document.body.addEventListener('htmx:pushedIntoHistory', () => {
                syncContextLinks(contextRoot);
            });
            document.body.addEventListener('htmx:afterSettle', () => {
                syncContextLinks(contextRoot);
            });
            window.addEventListener('popstate', () => {
                syncContextLinks(contextRoot);
            });

            contextRoot.addEventListener('click', (event) => {
                const sportSwitch = event.target.closest('[data-sport-switch]');

                if (sportSwitch instanceof HTMLElement) {
                    event.preventDefault();
                    navigateContext(contextRoot, sportSwitch, 'sport');

                    return;
                }

                const teamSwitch = event.target.closest('[data-team-switch]');

                if (teamSwitch instanceof HTMLElement) {
                    event.preventDefault();
                    navigateContext(contextRoot, teamSwitch, 'team');
                }
            });
        });
};

export {
    initializeManagementContext,
};
